<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Transfer Webchat" class="d-icon d-icon--transfer-webchat" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M1 7.962a.5.5 0 1 1 1 0v2.293l1.146-1.147.077-.062a.5.5 0 0 1 .277-.084h6a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1-1.5 1.5H3.707l-1.853 1.853A.5.5 0 0 1 1 11.462v-3.5Zm.396-4.874a.5.5 0 0 1 .772.629l-.064.078-.01.009-.024.025-.093.093-.27.27H3.5a.5.5 0 0 1 0 1H1.707l.397.396a.5.5 0 1 1-.708.707l-1.25-1.25a.5.5 0 0 1 0-.707L1.27 3.215l.092-.094.026-.024.008-.01Zm2.5-2.98a.5.5 0 0 1 .708 0l1.25 1.25a.5.5 0 0 1 0 .707l-1.25 1.25a.5.5 0 1 1-.708-.707l.397-.396H2.5a.5.5 0 0 1 0-1h1.793L3.896.815a.5.5 0 0 1 0-.707Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconTransferWebchat',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
